export const countries = [ 
    {value: 'Afghanistan', label: 'AF', currency: 'AFN', currencySymbol: '؋'}, 
    {value: 'Åland Islands', label: 'AX', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Albania', label: 'AL', currency: 'ALL', currencySymbol: 'L'}, 
    {value: 'Algeria', label: 'DZ', currency: 'DZD', currencySymbol: 'د.ج'}, 
    {value: 'American Samoa', label: 'AS', currency: 'USD', currencySymbol: '$'}, 
    {value: 'AndorrA', label: 'AD', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Angola', label: 'AO', currency: 'AOA', currencySymbol: 'Kz'}, 
    {value: 'Anguilla', label: 'AI', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Antarctica', label: 'AQ', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Antigua and Barbuda', label: 'AG', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Argentina', label: 'AR', currency: 'ARS', currencySymbol: '$'}, 
    {value: 'Armenia', label: 'AM', currency: 'AMD', currencySymbol: '֏'}, 
    {value: 'Aruba', label: 'AW', currency: 'AWG', currencySymbol: 'ƒ'}, 
    {value: 'Australia', label: 'AU', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Austria', label: 'AT', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Azerbaijan', label: 'AZ', currency: 'AZN', currencySymbol: '₼'}, 
    {value: 'Bahamas', label: 'BS', currency: 'BSD', currencySymbol: '$'}, 
    {value: 'Bahrain', label: 'BH', currency: 'BHD', currencySymbol: '.د.ب'}, 
    {value: 'Bangladesh', label: 'BD', currency: 'BDT', currencySymbol: '৳'}, 
    {value: 'Barbados', label: 'BB', currency: 'BBD', currencySymbol: '$'}, 
    {value: 'Belarus', label: 'BY', currency: 'BYN', currencySymbol: 'Br'}, 
    {value: 'Belgium', label: 'BE', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Belize', label: 'BZ', currency: 'BZD', currencySymbol: '$'}, 
    {value: 'Benin', label: 'BJ', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Bermuda', label: 'BM', currency: 'BMD', currencySymbol: '$'}, 
    {value: 'Bhutan', label: 'BT', currency: 'BTN', currencySymbol: 'Nu.'}, 
    {value: 'Bolivia', label: 'BO', currency: 'BOB', currencySymbol: 'Bs.'}, 
    {value: 'Bosnia and Herzegovina', label: 'BA', currency: 'BAM', currencySymbol: 'KM'}, 
    {value: 'Botswana', label: 'BW', currency: 'BWP', currencySymbol: 'P'}, 
    {value: 'Bouvet Island', label: 'BV', currency: 'NOK', currencySymbol: 'kr'}, 
    {value: 'Brazil', label: 'BR', currency: 'BRL', currencySymbol: 'R$'}, 
    {value: 'British Indian Ocean Territory', label: 'IO', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Brunei Darussalam', label: 'BN', currency: 'BND', currencySymbol: '$'}, 
    {value: 'Bulgaria', label: 'BG', currency: 'BGN', currencySymbol: 'лв'}, 
    {value: 'Burkina Faso', label: 'BF', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Burundi', label: 'BI', currency: 'BIF', currencySymbol: 'FBu'}, 
    {value: 'Cambodia', label: 'KH', currency: 'KHR', currencySymbol: '៛'}, 
    {value: 'Cameroon', label: 'CM', currency: 'XAF', currencySymbol: 'FCFA'}, 
    {value: 'Canada', label: 'CA', currency: 'CAD', currencySymbol: '$'}, 
    {value: 'Cape Verde', label: 'CV', currency: 'CVE', currencySymbol: '$'}, 
    {value: 'Cayman Islands', label: 'KY', currency: 'KYD', currencySymbol: '$'}, 
    {value: 'Central African Republic', label: 'CF', currency: 'XAF', currencySymbol: 'FCFA'}, 
    {value: 'Chad', label: 'TD', currency: 'XAF', currencySymbol: 'FCFA'}, 
    {value: 'Chile', label: 'CL', currency: 'CLP', currencySymbol: '$'}, 
    {value: 'China', label: 'CN', currency: 'CNY', currencySymbol: '¥'}, 
    {value: 'Christmas Island', label: 'CX', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Cocos (Keeling) Islands', label: 'CC', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Colombia', label: 'CO', currency: 'COP', currencySymbol: '$'}, 
    {value: 'Comoros', label: 'KM', currency: 'KMF', currencySymbol: 'CF'}, 
    {value: 'Congo', label: 'CG', currency: 'XAF', currencySymbol: 'FCFA'}, 
    {value: 'Congo, The Democratic Republic of the', label: 'CD', currency: 'CDF', currencySymbol: 'FC'}, 
    {value: 'Cook Islands', label: 'CK', currency: 'NZD', currencySymbol: '$'}, 
    {value: 'Costa Rica', label: 'CR', currency: 'CRC', currencySymbol: '₡'}, 
    {value: 'Cote D\'Ivoire', label: 'CI', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Croatia', label: 'HR', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Cuba', label: 'CU', currency: 'CUP', currencySymbol: '$'}, 
    {value: 'Cyprus', label: 'CY', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Czech Republic', label: 'CZ', currency: 'CZK', currencySymbol: 'Kč'}, 
    {value: 'Denmark', label: 'DK', currency: 'DKK', currencySymbol: 'kr'}, 
    {value: 'Djibouti', label: 'DJ', currency: 'DJF', currencySymbol: 'Fdj'}, 
    {value: 'Dominica', label: 'DM', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Dominican Republic', label: 'DO', currency: 'DOP', currencySymbol: '$'}, 
    {value: 'Ecuador', label: 'EC', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Egypt', label: 'EG', currency: 'EGP', currencySymbol: '£'}, 
    {value: 'El Salvador', label: 'SV', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Equatorial Guinea', label: 'GQ', currency: 'XAF', currencySymbol: 'FCFA'}, 
    {value: 'Eritrea', label: 'ER', currency: 'ERN', currencySymbol: 'Nfk'}, 
    {value: 'Estonia', label: 'EE', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Ethiopia', label: 'ET', currency: 'ETB', currencySymbol: 'Br'}, 
    {value: 'Falkland Islands (Malvinas)', label: 'FK', currency: 'FKP', currencySymbol: '£'}, 
    {value: 'Faroe Islands', label: 'FO', currency: 'DKK', currencySymbol: 'kr'}, 
    {value: 'Fiji', label: 'FJ', currency: 'FJD', currencySymbol: '$'}, 
    {value: 'Finland', label: 'FI', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'France', label: 'FR', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'French Guiana', label: 'GF', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'French Polynesia', label: 'PF', currency: 'XPF', currencySymbol: '₣'}, 
    {value: 'French Southern Territories', label: 'TF', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Gabon', label: 'GA', currency: 'XAF', currencySymbol: 'FCFA'}, 
    {value: 'Gambia', label: 'GM', currency: 'GMD', currencySymbol: 'D'}, 
    {value: 'Georgia', label: 'GE', currency: 'GEL', currencySymbol: '₾'}, 
    {value: 'Germany', label: 'DE', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Ghana', label: 'GH', currency: 'GHS', currencySymbol: '₵'}, 
    {value: 'Gibraltar', label: 'GI', currency: 'GIP', currencySymbol: '£'}, 
    {value: 'Greece', label: 'GR', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Greenland', label: 'GL', currency: 'DKK', currencySymbol: 'kr'}, 
    {value: 'Grenada', label: 'GD', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Guadeloupe', label: 'GP', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Guam', label: 'GU', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Guatemala', label: 'GT', currency: 'GTQ', currencySymbol: 'Q'}, 
    {value: 'Guernsey', label: 'GG', currency: 'GBP', currencySymbol: '£'}, 
    {value: 'Guinea', label: 'GN', currency: 'GNF', currencySymbol: 'FG'}, 
    {value: 'Guinea-Bissau', label: 'GW', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Guyana', label: 'GY', currency: 'GYD', currencySymbol: '$'}, 
    {value: 'Haiti', label: 'HT', currency: 'HTG', currencySymbol: 'G'}, 
    {value: 'Heard Island and Mcdonald Islands', label: 'HM', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Holy See (Vatican City State)', label: 'VA', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Honduras', label: 'HN', currency: 'HNL', currencySymbol: 'L'}, 
    {value: 'Hong Kong', label: 'HK', currency: 'HKD', currencySymbol: '$'}, 
    {value: 'Hungary', label: 'HU', currency: 'HUF', currencySymbol: 'Ft'}, 
    {value: 'Iceland', label: 'IS', currency: 'ISK', currencySymbol: 'kr'}, 
    {value: 'India', label: 'IN', currency: 'INR', currencySymbol: '₹'}, 
    {value: 'Indonesia', label: 'ID', currency: 'IDR', currencySymbol: 'Rp'}, 
    {value: 'Iran, Islamic Republic Of', label: 'IR', currency: 'IRR', currencySymbol: '﷼'}, 
    {value: 'Iraq', label: 'IQ', currency: 'IQD', currencySymbol: 'ع.د'}, 
    {value: 'Ireland', label: 'IE', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Isle of Man', label: 'IM', currency: 'GBP', currencySymbol: '£'}, 
    {value: 'Israel', label: 'IL', currency: 'ILS', currencySymbol: '₪'}, 
    {value: 'Italy', label: 'IT', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Jamaica', label: 'JM', currency: 'JMD', currencySymbol: '$'}, 
    {value: 'Japan', label: 'JP', currency: 'JPY', currencySymbol: '¥'}, 
    {value: 'Jersey', label: 'JE', currency: 'GBP', currencySymbol: '£'}, 
    {value: 'Jordan', label: 'JO', currency: 'JOD', currencySymbol: 'د.ا'}, 
    {value: 'Kazakhstan', label: 'KZ', currency: 'KZT', currencySymbol: '₸'}, 
    {value: 'Kenya', label: 'KE', currency: 'KES', currencySymbol: 'KSh'}, 
    {value: 'Kiribati', label: 'KI', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Korea, Democratic People\'S Republic of', label: 'KP', currency: 'KPW', currencySymbol: '₩'}, 
    {value: 'Korea, Republic of', label: 'KR', currency: 'KRW', currencySymbol: '₩'}, 
    {value: 'Kuwait', label: 'KW', currency: 'KWD', currencySymbol: 'د.ك'}, 
    {value: 'Kyrgyzstan', label: 'KG', currency: 'KGS', currencySymbol: 'с'}, 
    {value: 'Lao People\'S Democratic Republic', label: 'LA', currency: 'LAK', currencySymbol: '₭'}, 
    {value: 'Latvia', label: 'LV', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Lebanon', label: 'LB', currency: 'LBP', currencySymbol: 'ل.ل'}, 
    {value: 'Lesotho', label: 'LS', currency: 'LSL', currencySymbol: 'L'}, 
    {value: 'Liberia', label: 'LR', currency: 'LRD', currencySymbol: '$'}, 
    {value: 'Libyan Arab Jamahiriya', label: 'LY', currency: 'LYD', currencySymbol: 'ل.د'}, 
    {value: 'Liechtenstein', label: 'LI', currency: 'CHF', currencySymbol: 'Fr'}, 
    {value: 'Lithuania', label: 'LT', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Luxembourg', label: 'LU', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Macao', label: 'MO', currency: 'MOP', currencySymbol: 'MOP$'}, 
    {value: 'Macedonia, The Former Yugoslav Republic of', label: 'MK', currency: 'MKD', currencySymbol: 'ден'}, 
    {value: 'Madagascar', label: 'MG', currency: 'MGA', currencySymbol: 'Ar'}, 
    {value: 'Malawi', label: 'MW', currency: 'MWK', currencySymbol: 'MK'}, 
    {value: 'Malaysia', label: 'MY', currency: 'MYR', currencySymbol: 'RM'}, 
    {value: 'Maldives', label: 'MV', currency: 'MVR', currencySymbol: 'Rf'}, 
    {value: 'Mali', label: 'ML', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Malta', label: 'MT', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Marshall Islands', label: 'MH', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Martinique', label: 'MQ', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Mauritania', label: 'MR', currency: 'MRU', currencySymbol: 'UM'}, 
    {value: 'Mauritius', label: 'MU', currency: 'MUR', currencySymbol: '₨'}, 
    {value: 'Mayotte', label: 'YT', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Mexico', label: 'MX', currency: 'MXN', currencySymbol: '$'}, 
    {value: 'Micronesia, Federated States of', label: 'FM', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Moldova, Republic of', label: 'MD', currency: 'MDL', currencySymbol: 'L'}, 
    {value: 'Monaco', label: 'MC', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Mongolia', label: 'MN', currency: 'MNT', currencySymbol: '₮'}, 
    {value: 'Montserrat', label: 'MS', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Morocco', label: 'MA', currency: 'MAD', currencySymbol: 'د.م.'}, 
    {value: 'Mozambique', label: 'MZ', currency: 'MZN', currencySymbol: 'MT'}, 
    {value: 'Myanmar', label: 'MM', currency: 'MMK', currencySymbol: 'K'}, 
    {value: 'Namibia', label: 'NA', currency: 'NAD', currencySymbol: '$'}, 
    {value: 'Nauru', label: 'NR', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Nepal', label: 'NP', currency: 'NPR', currencySymbol: '₨'}, 
    {value: 'Netherlands', label: 'NL', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Netherlands Antilles', label: 'AN', currency: 'ANG', currencySymbol: 'ƒ'}, 
    {value: 'New Caledonia', label: 'NC', currency: 'XPF', currencySymbol: '₣'}, 
    {value: 'New Zealand', label: 'NZ', currency: 'NZD', currencySymbol: '$'}, 
    {value: 'Nicaragua', label: 'NI', currency: 'NIO', currencySymbol: 'C$'}, 
    {value: 'Niger', label: 'NE', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Nigeria', label: 'NG', currency: 'NGN', currencySymbol: '₦'}, 
    {value: 'Niue', label: 'NU', currency: 'NZD', currencySymbol: '$'}, 
    {value: 'Norfolk Island', label: 'NF', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Northern Mariana Islands', label: 'MP', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Norway', label: 'NO', currency: 'NOK', currencySymbol: 'kr'}, 
    {value: 'Oman', label: 'OM', currency: 'OMR', currencySymbol: 'ر.ع.'}, 
    {value: 'Pakistan', label: 'PK', currency: 'PKR', currencySymbol: '₨'}, 
    {value: 'Palau', label: 'PW', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Palestinian Territory, Occupied', label: 'PS', currency: 'ILS', currencySymbol: '₪'}, 
    {value: 'Panama', label: 'PA', currency: 'PAB', currencySymbol: 'B/.'}, 
    {value: 'Papua New Guinea', label: 'PG', currency: 'PGK', currencySymbol: 'K'}, 
    {value: 'Paraguay', label: 'PY', currency: 'PYG', currencySymbol: '₲'}, 
    {value: 'Peru', label: 'PE', currency: 'PEN', currencySymbol: 'S/.'}, 
    {value: 'Philippines', label: 'PH', currency: 'PHP', currencySymbol: '₱'}, 
    {value: 'Pitcairn', label: 'PN', currency: 'NZD', currencySymbol: '$'}, 
    {value: 'Poland', label: 'PL', currency: 'PLN', currencySymbol: 'zł'}, 
    {value: 'Portugal', label: 'PT', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Puerto Rico', label: 'PR', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Qatar', label: 'QA', currency: 'QAR', currencySymbol: 'ر.ق'}, 
    {value: 'Reunion', label: 'RE', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Romania', label: 'RO', currency: 'RON', currencySymbol: 'lei'}, 
    {value: 'Russian Federation', label: 'RU', currency: 'RUB', currencySymbol: '₽'}, 
    {value: 'RWANDA', label: 'RW', currency: 'RWF', currencySymbol: 'FRw'}, 
    {value: 'Saint Helena', label: 'SH', currency: 'SHP', currencySymbol: '£'}, 
    {value: 'Saint Kitts and Nevis', label: 'KN', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Saint Lucia', label: 'LC', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Saint Pierre and Miquelon', label: 'PM', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Saint Vincent and the Grenadines', label: 'VC', currency: 'XCD', currencySymbol: '$'}, 
    {value: 'Samoa', label: 'WS', currency: 'WST', currencySymbol: 'T'}, 
    {value: 'San Marino', label: 'SM', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Sao Tome and Principe', label: 'ST', currency: 'STN', currencySymbol: 'Db'}, 
    {value: 'Saudi Arabia', label: 'SA', currency: 'SAR', currencySymbol: 'ر.س'}, 
    {value: 'Senegal', label: 'SN', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Serbia and Montenegro', label: 'CS', currency: 'RSD', currencySymbol: 'дин.'}, 
    {value: 'Seychelles', label: 'SC', currency: 'SCR', currencySymbol: '₨'}, 
    {value: 'Sierra Leone', label: 'SL', currency: 'SLL', currencySymbol: 'Le'}, 
    {value: 'Singapore', label: 'SG', currency: 'SGD', currencySymbol: '$'}, 
    {value: 'Slovakia', label: 'SK', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Slovenia', label: 'SI', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Solomon Islands', label: 'SB', currency: 'SBD', currencySymbol: '$'}, 
    {value: 'Somalia', label: 'SO', currency: 'SOS', currencySymbol: 'Sh.So.'}, 
    {value: 'South Africa', label: 'ZA', currency: 'ZAR', currencySymbol: 'R'}, 
    {value: 'South Georgia and the South Sandwich Islands', label: 'GS', currency: 'GBP', currencySymbol: '£'}, 
    {value: 'Spain', label: 'ES', currency: 'EUR', currencySymbol: '€'}, 
    {value: 'Sri Lanka', label: 'LK', currency: 'LKR', currencySymbol: 'Rs'}, 
    {value: 'Sudan', label: 'SD', currency: 'SDG', currencySymbol: 'ج.س.'}, 
    {value: 'Surivalue', label: 'SR', currency: 'SRD', currencySymbol: '$'}, 
    {value: 'Svalbard and Jan Mayen', label: 'SJ', currency: 'NOK', currencySymbol: 'kr'}, 
    {value: 'Swaziland', label: 'SZ', currency: 'SZL', currencySymbol: 'L'}, 
    {value: 'Sweden', label: 'SE', currency: 'SEK', currencySymbol: 'kr'}, 
    {value: 'Switzerland', label: 'CH', currency: 'CHF', currencySymbol: 'Fr'}, 
    {value: 'Syrian Arab Republic', label: 'SY', currency: 'SYP', currencySymbol: '£'}, 
    {value: 'Taiwan, Province of China', label: 'TW', currency: 'TWD', currencySymbol: '$'}, 
    {value: 'Tajikistan', label: 'TJ', currency: 'TJS', currencySymbol: 'ЅM'}, 
    {value: 'Tanzania, United Republic of', label: 'TZ', currency: 'TZS', currencySymbol: 'TSh'}, 
    {value: 'Thailand', label: 'TH', currency: 'THB', currencySymbol: '฿'}, 
    {value: 'Timor-Leste', label: 'TL', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Togo', label: 'TG', currency: 'XOF', currencySymbol: 'CFA'}, 
    {value: 'Tokelau', label: 'TK', currency: 'NZD', currencySymbol: '$'}, 
    {value: 'Tonga', label: 'TO', currency: 'TOP', currencySymbol: 'T$'}, 
    {value: 'Trinidad and Tobago', label: 'TT', currency: 'TTD', currencySymbol: '$'}, 
    {value: 'Tunisia', label: 'TN', currency: 'TND', currencySymbol: 'د.ت'}, 
    {value: 'Turkey', label: 'TR', currency: 'TRY', currencySymbol: '₺'}, 
    {value: 'Turkmenistan', label: 'TM', currency: 'TMT', currencySymbol: 'm'}, 
    {value: 'Turks and Caicos Islands', label: 'TC', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Tuvalu', label: 'TV', currency: 'AUD', currencySymbol: '$'}, 
    {value: 'Uganda', label: 'UG', currency: 'UGX', currencySymbol: 'USh'}, 
    {value: 'Ukraine', label: 'UA', currency: 'UAH', currencySymbol: '₴'}, 
    {value: 'United Arab Emirates', label: 'AE', currency: 'AED', currencySymbol: 'د.إ'}, 
    {value: 'United Kingdom', label: 'GB', currency: 'GBP', currencySymbol: '£'}, 
    {value: 'United States', label: 'US', currency: 'USD', currencySymbol: '$'}, 
    {value: 'United States Minor Outlying Islands', label: 'UM', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Uruguay', label: 'UY', currency: 'UYU', currencySymbol: '$'}, 
    {value: 'Uzbekistan', label: 'UZ', currency: 'UZS', currencySymbol: 'so\'m'}, 
    {value: 'Vanuatu', label: 'VU', currency: 'VUV', currencySymbol: 'VT'}, 
    {value: 'Venezuela', label: 'VE', currency: 'VES', currencySymbol: 'Bs.'}, 
    {value: 'Viet Nam', label: 'VN', currency: 'VND', currencySymbol: '₫'}, 
    {value: 'Virgin Islands, British', label: 'VG', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Virgin Islands, U.S.', label: 'VI', currency: 'USD', currencySymbol: '$'}, 
    {value: 'Wallis and Futuna', label: 'WF', currency: 'XPF', currencySymbol: '₣'}, 
    {value: 'Western Sahara', label: 'EH', currency: 'MAD', currencySymbol: 'د.م.'}, 
    {value: 'Yemen', label: 'YE', currency: 'YER', currencySymbol: '﷼'}, 
    {value: 'Zambia', label: 'ZM', currency: 'ZMW', currencySymbol: 'ZK'}, 
    {value: 'Zimbabwe', label: 'ZW', currency: 'ZWL', currencySymbol: '$'} 
  ]